import { claimsModalEditingModes } from '../claimsModal/claimsModal.constants';
import { castToBoolean } from '../../../../../lib/util';

const initialPositionsToDisplay = 10;
const incrementPositionsBy = 10;

class PositionsPanelController {
  constructor(
    $q,
    $scope,
    LogService,
    APIService,
    adhocModal,
  ) {
    "ngInject";
    this.$q = $q;
    this.$scope = $scope;
    this.LogService = LogService;
    this.APIService = APIService;
    this.adhocModal = adhocModal;

    this._numPositionsToDisplay = initialPositionsToDisplay;
  }

  set staffUser(staffUser) {
    this._staffUser = staffUser;
  }

  get staffUser() {
    return this._staffUser;
  }

  set positions(positions) {
    this._positions = positions;
  }

  get positions() {
    return this._positions;
  }

  get useMandatoryCheckIn() {
    return this.staffUser.use_mandatory_check_ins ?? false;
  }

  /**
   * Requirements:
   * 1. Mandatory checkins
   * 2. Prompt Recap Checkout Claim Flag
   * 3. Any position that has been checked out, has its claims.
   * 4. Has a recap response
   */
  get positionRequiringClaim() {
    if (!this.useMandatoryCheckIn) {
      return false
    }

    const requirements = this.positions.find(position => {
      const promptRecapCheckoutClaimFlag =  castToBoolean(position.event.prompt_recap_checkout_claim)
      const isCheckedOut = position.checkin && position.checkin.length && position.checkin[position.checkin.length -1 ].type == 'out'
      const noClaims = this.staffUser.getClaimsForEventId(position.events_id).length < 1
      const response = position.recapResponse
      return promptRecapCheckoutClaimFlag && isCheckedOut && noClaims && response
    })

    return !!requirements
  }
  
  /**
   * Used to determine if the positions panel should
   * lock further check-ins.
   * 
   * If the use mandatory check in is not enabled, this lock
   * does not apply.
   * 
   * If the user is not checked in to any position,
   * this lock will not apply.
   * 
   * If the user is checked in for the current position, this lock
   * will not apply. Otherwise, we need to prevent the users from 
   * checking in to other positions.
   * 
   * @param {position} position 
   * @returns boolean
   */
  lockForMandatoryCheckIn(position) {

    if (this.useMandatoryCheckIn) {      
      if (position.current_checkin_status == 'in') {
        return false;
      }
        return true
    }
    return false
  }

  /**
   * Used to determine if the user is checked in to another position.
   * 
   * @param {position} position
   * @returns boolean
   * 
   */
  checkOtherPositionLoggedIn(position) {
    return this._positions.some(p => p.current_checkin_status === 'in' && p.id !== position.id);
  }

  /**
   * Returns true if the user is checked in to any position.
   */
  get isCheckedIn() {
    return this._positions.some(position => position.current_checkin_status == 'in');
  }

  get isOnline() {
    return this.APIService && this.APIService.isOnline;
  }

  get numPositionsToDisplay() {
    return this._numPositionsToDisplay;
  }

  get showLoadMoreButton() {
    return this.positions && this.numPositionsToDisplay < this.positions.length;
  }

  set showAddAdhocButton(showAddAdhocButton) {
    this._showAddAdhocButton = showAddAdhocButton;
  }

  get showAddAdhocButton() {
    return this._showAddAdhocButton;
  }

  set initiallyOpen(open) {
    this._initiallyOpen = open;
  }

  get initiallyOpen() {
    return this._initiallyOpen;
  }

  incrementNumPositionsToDisplay() {
    this._numPositionsToDisplay += incrementPositionsBy;
  }

  addAdhoc() {
    return this.adhocModal({
      staffUser: this.staffUser,
    })
      .then(() => {
      });
  }

  toggleCollapsed() {
    if (this.onToggleCollapsed) {
      this.onToggleCollapsed();
    } else {
      this.LogService && this.LogService.warn(`PositionsPanelController.toggleCollapsed no callback found`);
    }
  }
}

export default PositionsPanelController;

